import styled from 'styled-components';
import AlertSolidIcon from '#/shared/components/GeneratedIcons/trimet/AlertSolid';
import SnowIcon from '#/shared/components/GeneratedIcons/trimet/Snow';

export const ServiceAlertIcon = styled(AlertSolidIcon).attrs(props => ({
  fill: props.theme.normalAlertIconFill,
  height: 58,
  width: 58,
}))``;

export const PriorityAlertIcon = styled(AlertSolidIcon).attrs(props => ({
  fill: props.theme.buttonText1,
}))`
  height: 58px;
  width: 58px;
`;

export const SnowAlertIcon = styled(SnowIcon).attrs(props => ({
  fill: props.theme.buttonText1,
}))`
  height: 60px;
  width: 55px;
`;

// color values are keys that map to values in the app theme and are used
// on peer and background elements of these icons
export const AlertStyleEnum = Object.freeze({
  normal: {
    Icon: ServiceAlertIcon,
    textHoverColor: 'normalViewTextHover',
    textColor: 'normalAlertHoverColor',
    backgroundColor: 'normalAlertBackgroundColor',
    hoverColor: 'normalAlertHoverColor',
    borderColor: 'normalAlertBorderColor',
    moreTextColor: 'primaryFontColor',
  },
  priority: {
    Icon: PriorityAlertIcon,
    textHoverColor: 'primaryFontColorReverse',
    textColor: 'priorityViewTextHover',
    backgroundColor: 'priorityAlertBackgroundColor',
    hoverColor: 'priorityAlertHoverColor',
    borderColor: 'priorityAlertBorderColor',
    moreTextColor: 'primaryFontColorReverse',
  },
  snow: {
    Icon: SnowAlertIcon,
    textHoverColor: 'primaryFontColorReverse',
    textColor: 'priorityViewTextHover',
    backgroundColor: 'snowAlertBackgroundColor',
    hoverColor: 'snowAlertHoverColor',
    borderColor: 'snowAlertBorderColor',
    moreTextColor: 'primaryFontColorReverse',
  },
});
